import React, { useEffect, useState } from 'react';
import { getFieldInfoByName } from '../collection/Util';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import FormFieldWithLabel from '../../../common/FormFieldWithLabel';
import CustomSelect from '../../../../common/formElements/CustomSelect';
import CustomLoader from '../../../common/CustomLoader';
import CustomSelectWithValues from '../../../../common/formElements/CustomSelectWithValues';

export const SwitchEntityForm = ({
  projectId,
  selectedEvent,
  eventAction,
  actionData,
  events,
  actions,
  hideModal,
  showLoaderForAction,
  version,
}) => {
  const [isMultiTenantPluginInstalled, setIsMultiTenantPluginInstalled] = useState(false);

  useEffect(() => {
    const { plugins } = events || '';
    const multiTenantPlugin = plugins && plugins.find((e) => e.code === 'MULTI_TENANT_SAAS');
    setIsMultiTenantPluginInstalled(!!multiTenantPlugin);
  }, []);

  const createActionSettingsSchema = (actionData, eventAction) => {
    let schema = {};
    actionData.args.forEach((args) => {
      const dbParameters = eventAction.parameters.find((param) => {
        return param.name === args.name;
      });
      if (dbParameters) {
        schema[args.name] = dbParameters ? dbParameters.value : '';
      } else {
        schema[args.name] = args.value || '';
      }
    });
    return schema;
  };

  const collectionOptions = () => {
    let options = [{ value: '', label: 'Choose Collection' }];
    let collections = events ? events.collections : [];
    if (collections.length > 0) {
      options = options.concat(
        collections.map((collection) => {
          return { value: collection.collectionName, label: collection.collectionTitle };
        }),
      );
    }
    return options;
  };

  const handleSubmit = (values) => {
    let parameters = [];
    Object.keys(values).map((value) => {
      console.log('value', value);
      const action = actionData.args.find((param) => {
        return param.name === value;
      });
      parameters.push({ name: value, value: values[value], type: action.type });
    });

    let actionFormData = eventAction;
    actionFormData.parameters = parameters;
    actions.updateAction({
      projectId,
      version,
      eventId: selectedEvent.uuid,
      data: actionFormData,
    });
    hideModal();
  };

  const updateEntityByOptions = () => {
    let options = [
      { value: 'collectionUuid', label: 'Item Id of Collection' },
      { value: 'previousResponse', label: 'Item Id from Previous Step' },
      {
        value: 'currentLoggedInUser',
        label: 'Current LoggedIn User',
      },
    ];
    if (isMultiTenantPluginInstalled) {
      options.push({
        value: 'currentLoggedInUserTenant',
        label: 'Current LoggedIn User Tenant',
      });
    }
    options.push(
      { value: 'previousActionResponse', label: 'Browser Session' },
      // {
      //   value: 'previousActionFormData',
      //   label: 'Browser Session Form Data',
      // },
    );
    return options;
  };
  const getPageOptions = () => {
    const { pages } = events;
    const pageOptions =
      pages.length > 0 ? pages.map((item) => ({ value: item.slug, label: item.name })) : [];
    return pageOptions;
  };

  const browserStorageLocationOptions = () => {
    let options = [
      { value: 'SESSION_STORAGE', label: 'Session Storage (Default)' },
      { value: 'LOCAL_STORAGE', label: 'Local Storage' },
      { value: 'COOKIES', label: 'Cookies' },
      { value: 'INDEXED_DB', label: 'IndexedDB' },
    ];
    return options;
  };

  return (
    <Formik
      enableReinitialize={true}
      initialValues={createActionSettingsSchema(actionData, eventAction)}
      onSubmit={(values, { setSubmitting, resetForm }) => {
        handleSubmit(values);
      }}
    >
      {({ isSubmitting, values, setFieldValue, setFieldTouched, errors }) => (
        <Form>
          <div className="row">
            <div className="col-12">
              <div className="form-group">
                <FormFieldWithLabel
                  cta={false}
                  label="Collection (Browser Storage)"
                  icon="select"
                  infoIcon={true}
                  infoDescription={
                    'Select an Collection (Browser Storage) which you want to update.'
                  }
                >
                  <CustomSelect
                    name={'collection'}
                    isMulti={false}
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    options={collectionOptions()}
                    value={values['collection']}
                    // onChangeValue={this.handleChange}
                  />
                  <ErrorMessage name={'collection'}>
                    {(msg) => <p className="text-error">{msg}</p>}
                  </ErrorMessage>
                </FormFieldWithLabel>
              </div>
            </div>
            <div className="col-12">
              <div className="form-group">
                <FormFieldWithLabel
                  cta={false}
                  label="Switch Collection (Browser Storage) By"
                  icon="select"
                  infoIcon={true}
                  infoDescription={getFieldInfoByName('updateEntityBy')}
                >
                  <CustomSelect
                    name={'updateEntityBy'}
                    isMulti={false}
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    options={updateEntityByOptions()}
                    value={values['updateEntityBy']}
                    // onChangeValue={handleChange}
                  />
                </FormFieldWithLabel>
              </div>
            </div>
            {[
              'previousActionFormData',
              'currentLoggedInUser',
              'currentLoggedInUserTenant',
            ].includes(values['updateEntityBy']) && (
              <div className="col-12">
                <div className="form-group">
                  <FormFieldWithLabel
                    cta={false}
                    label="Item Id JSON Path"
                    icon="text"
                    infoIcon={true}
                    infoDescription={getFieldInfoByName('storageCustomKey')}
                  >
                    <Field
                      name="storageCustomKey"
                      type="text"
                      placeholder={`Item Id JSON Path ${
                        ['currentLoggedInUser', 'currentLoggedInUserTenant'].includes(
                          values['updateEntityBy'],
                        )
                          ? ' (Optional)'
                          : ''
                      }`}
                      className="form-control form-control-sm"
                    />
                  </FormFieldWithLabel>
                </div>
              </div>
            )}
            {['previousActionResponse'].includes(values['updateEntityBy']) && (
              <div className="col-12">
                <div className="form-group">
                  <FormFieldWithLabel
                    cta={false}
                    label="Item Id JSON Path"
                    icon="text"
                    infoIcon={true}
                    infoDescription={`Enter the session value JSON path of your web browser storage from where action should read the data.`}
                  >
                    <Field
                      name="storageCustomKey"
                      type="text"
                      placeholder={`Item Id JSON Path`}
                      className="form-control form-control-sm"
                    />
                  </FormFieldWithLabel>
                  <ErrorMessage name="storageCustomKey" component="p" className="text-error ml-5" />
                </div>
                <div className="form-group">
                  <FormFieldWithLabel
                    cta={false}
                    label="Session Storage Location (Optional)"
                    icon="select"
                    infoIcon={true}
                    infoDescription={`Select the browser storage location where the JSON path exist in your web browser storage.`}
                  >
                    <CustomSelect
                      name={'storageCustomKeyLocation'}
                      isMulti={false}
                      onChange={setFieldValue}
                      onBlur={setFieldTouched}
                      options={browserStorageLocationOptions()}
                      value={values['storageCustomKeyLocation']}
                      placeholder={'Session Storage Location (Optional)'}
                    />
                  </FormFieldWithLabel>

                  <small style={{ paddingLeft: '12%' }}>
                    Select a JSON path's browser storage location (Default: Session Storage).
                  </small>
                  <ErrorMessage
                    name="storageCustomKeyLocation"
                    component="p"
                    className="text-error ml-5"
                  />
                </div>
              </div>
            )}
            <div className="col-12">
              <div className="form-group">
                <FormFieldWithLabel
                  cta={false}
                  label="Page to Land on"
                  icon="select"
                  infoIcon={true}
                  infoDescription={getFieldInfoByName('page')}
                >
                  <CustomSelectWithValues
                    name={'page'}
                    isMulti={false}
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    options={getPageOptions()}
                    value={values['page']}
                    formValues={values}
                    setFieldValue={setFieldValue}
                    // onChangeOption={handlePageChange}
                  />
                </FormFieldWithLabel>
              </div>
            </div>
            <div className="col-12">
              <div className="form-group">
                <FormFieldWithLabel
                  cta={false}
                  label="Success Message"
                  icon="text"
                  infoIcon={true}
                  infoDescription={getFieldInfoByName('successMessage')}
                >
                  <Field
                    name="successMessage"
                    type="text"
                    placeholder="(Optional) Enter custom success message."
                    className="form-control form-control-sm"
                  />
                </FormFieldWithLabel>
              </div>
            </div>
            <div className="col-12">
              <div className="form-group">
                <FormFieldWithLabel
                  cta={false}
                  label="Error Message"
                  icon="text"
                  infoIcon={true}
                  infoDescription={getFieldInfoByName('errorMessage')}
                >
                  <Field
                    name="errorMessage"
                    type="text"
                    placeholder="(Optional) Enter custom error message."
                    className="form-control form-control-sm"
                  />
                </FormFieldWithLabel>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 text-left">
              <button
                type="button"
                className="btn btn-outline-secondary btn-sm"
                onClick={hideModal}
              >
                <span>
                  <i className="wb webconnect-times"></i>&nbsp;Cancel
                </span>
              </button>
            </div>
            <div className="col-md-6 text-right">
              <button type="submit" className="btn btn-theme-submit btn-sm">
                <i className="wb webconnect-save-regular"></i>&nbsp;Save&nbsp;
                <CustomLoader loading={showLoaderForAction} />
              </button>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};
